var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandSlowenien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "land_slowenien") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,13l.2-4.1ZM14.1,8.9l.3-.1a9,9,0,0,1,7.2,0h.3L21.7,13H32A15,15,0,0,0,3.7,13H14.3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,13.4A4.81,4.81,0,0,1,18,17.7a4.83,4.83,0,0,0,3.4-4.2v-.1Z",
    fill: "#0000bf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33,18a14.92,14.92,0,0,0-.8-5H21.6v.4A5.1,5.1,0,0,1,18,18a5.1,5.1,0,0,1-3.6-4.6V13H3.8a15,15,0,0,0,0,10H32.2A14.92,14.92,0,0,0,33,18Z",
    fill: "#0000bf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1,23H3.8a15,15,0,0,0,28.4,0ZM21.6,8.8v.1L21.4,13v.4A4.81,4.81,0,0,1,18,17.7a4.83,4.83,0,0,1-3.4-4.2l-.2-4.7H14l.3,4.2v.4A5.1,5.1,0,0,0,18,18a5.1,5.1,0,0,0,3.6-4.6V13l.3-4.1Z",
    fill: "#d50000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4,8.8l.3,4.6A4.92,4.92,0,0,0,18,17.7a4.83,4.83,0,0,0,3.4-4.2V13l.3-4.1V8.8A9,9,0,0,0,14.4,8.8Zm5.3,7.5A4.54,4.54,0,0,1,18,17.4a4.58,4.58,0,0,1-1.7-1,3.25,3.25,0,0,1-.4-.5.9.9,0,0,0,.4,0,.75.75,0,0,0,.2-.1,1.3,1.3,0,0,1,1,0,1,1,0,0,0,.7.1.63.63,0,0,0,.3-.1,1.3,1.3,0,0,1,1,0,.89.89,0,0,0,.6.1A2.52,2.52,0,0,1,19.7,16.3Zm.7-.8-.2.1a1,1,0,0,1-.7-.1,1.3,1.3,0,0,0-1,0,.75.75,0,0,1-.2.1,1,1,0,0,1-.8-.1,1.3,1.3,0,0,0-1,0l-.2.1a1.05,1.05,0,0,1-.7,0l-.2-.4h.2a1,1,0,0,0,.7.1h.2a1,1,0,0,1,.5-.2,1,1,0,0,1,.5.1,1,1,0,0,0,.8.1h.2a1,1,0,0,1,.5-.2,1,1,0,0,1,.5.1,1,1,0,0,0,.7.1h.3a.54.54,0,0,1,.1-.2Zm-1.7-7h.2l.1-.1.1.2h.3l-.2.2.2.2H19l-.1.2V9h-.3l.1-.2Zm-1,1.4h.2l.1-.2.1.3h.3l-.2.2.2.2H18l-.1.3-.1-.3h-.3l.2-.2Zm-1-1.4h.2l.1-.1.1.2h.3l-.2.2.2.2H17l-.1.2L16.8,9h-.3l.2-.2Zm.5,4.4L18,11l.9,1.8.6-.8,1.4,2a1,1,0,0,1-1,1,1,1,0,0,1-.5-.1.54.54,0,0,0-.2-.1,1,1,0,0,0-.7.1,1.3,1.3,0,0,1-1,0,1,1,0,0,0-.7-.1.76.76,0,0,0-.3.1,1,1,0,0,1-.5.1,1,1,0,0,1-1-1l1.5-2Z",
    fill: "#0000bf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9,10.4l.1.2.1-.2h.3l-.2-.2.2-.3-.3.1L18,9.7l-.1.3-.3-.1.2.3-.2.2ZM16.9,9l.1.2.1-.2h.3l-.2-.2.2-.2h-.3L17,8.4l-.1.2h-.3l.2.2-.2.2Zm2,0,.1.2.1-.2h.3l-.1-.2.1-.2h-.3L19,8.4l-.1.2h-.2l.1.2-.1.2Z",
    fill: "#ffdf00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15,14a1,1,0,0,0,1,1,1,1,0,0,0,.6,0,.75.75,0,0,1,.2-.1,1.05,1.05,0,0,1,.7,0,1,1,0,0,0,1,0,1,1,0,0,1,.8,0h.2a1,1,0,0,0,.5.2,1,1,0,0,0,1-1l-1.5-2-.6.8L18,11l-.9,1.8-.6-.8Zm5.5,1.2-.3.1a1.05,1.05,0,0,1-.7,0,1,1,0,0,0-1,0h-.3a1.05,1.05,0,0,1-.7,0,1,1,0,0,0-1,0h-.2a1,1,0,0,1-.8,0l-.1-.2.2.4a1,1,0,0,0,.7.1l.2-.1a1.3,1.3,0,0,1,1,0,1,1,0,0,0,.7.1,1,1,0,0,0,.3-.1,1,1,0,0,1,.5-.1,1.07,1.07,0,0,1,.4.1,1,1,0,0,0,.8.1h.1l.3-.4h-.1Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,15.8a1,1,0,0,0-1,0,.51.51,0,0,1-.3,0,1.05,1.05,0,0,1-.7,0,1,1,0,0,0-1,0h-.2a.9.9,0,0,1-.4,0,5.09,5.09,0,0,0,.3.5A4.52,4.52,0,0,0,18,17.4a4.58,4.58,0,0,0,1.7-1,3.25,3.25,0,0,0,.4-.5A.89.89,0,0,1,19.5,15.8Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandSlowenien);
export default __webpack_public_path__ + "static/media/land_slowenien.f8560bc029a9983b779914bb20592336.svg";
export { ForwardRef as ReactComponent };